import { useState, useEffect } from 'react'
import { useWindowSize } from '../hooks/useWindowSize'

const getCheckIsMobile = () => {
  const width = window.innerWidth
  const height = window.innerHeight

  const isPortraitMobile = width <= 480
  const isLandscapeMobile = width <= 1024 && height <= 480

  return isPortraitMobile || isLandscapeMobile
}

const getCheckIsTablet = () => window.screen.width > 767

const getCheckOrientation = (): string => {
  if (window?.screen?.orientation?.type) return window.screen.orientation.type.split('-')[0]

  // Fallback for devices that don't support screen.orientation
  if (window.matchMedia('(orientation: landscape)').matches) {
    return 'landscape'
  }

  return 'portrait'
}

const getCheckIsTabletLandscapeWide = () => {
  const isLandscape = getCheckOrientation() === 'landscape'
  const isTablet = getCheckIsTablet()
  const isWideScreen = window.screen.width > 1160 // Minimum width check
  return isLandscape && isTablet && isWideScreen
}

export default function useDeviceMetrics() {
  const [deviceInfo, setDeviceInfo] = useState({
    orientation: getCheckOrientation(),
    isMobile: getCheckIsMobile(),
    isTablet: getCheckIsTablet(),
    isTabletInLandscape: getCheckIsTabletLandscapeWide(),
  })

  const { width, height } = useWindowSize()

  useEffect(() => {
    setDeviceInfo({
      orientation: getCheckOrientation(),
      isMobile: getCheckIsMobile(),
      isTablet: getCheckIsTablet(),
      isTabletInLandscape: getCheckIsTabletLandscapeWide(),
    })
  }, [width, height])

  return deviceInfo
}
